import Svg, { SvgProps, Path } from 'react-native-svg';
import { memo } from 'react';
const SvgComponent = (props: SvgProps) => (
  <Svg fill="none" viewBox="0 0 111 26" {...props}>
    <Path d="m 2.5,15 a 2.5,2.5 0 0 1 0,-5 H 90 v 5 z M 90,0 v 25 l 20,-12.626 z" />
  </Svg>
);
const Memo = memo(SvgComponent);
export default Memo;
